import { render, staticRenderFns } from "./ClientAcceptMarketingSection.vue?vue&type=template&id=71db070b"
import script from "./ClientAcceptMarketingSection.vue?vue&type=script&lang=js"
export * from "./ClientAcceptMarketingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports